module.exports = __webpack_public_path__ + "img/boolzap-1.4f8f423a.png";